import store from '../store'

export function trackDataSearchedFilters(payload) {
  store.dispatch('initSearchedFiltersStates')
  store.dispatch('setModelTypeSearchedFilters', payload.type)
  store.dispatch('setPayloadSearchedFilters', {[payload.type]: payload.data})
  if (store.getters.ignition) {
    store.dispatch('setModelTypeSearchedFilters', '_ignition')
    store.dispatch('setPayloadSearchedFilters', {ignition: store.getters.ignition})
  }
  if (store.getters.stateVehicleSelected.length > 0) {
    store.dispatch('setModelTypeSearchedFilters', '_stopped-time')
    store.dispatch('setPayloadSearchedFilters', {state: store.getters.stateVehicleSelected})
  }
}



// WEBPACK FOOTER //
// ./src/utils/trackDataLogs.js